/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	/**
	 * @interface DashboardSettingsAPI
	 * @hideconstructor
	 * @classdesc API interface to be implemented as a bootstrap feature in order to provide global dashboard settings
	 * @example dashboardAPI.getFeature('DashboardSettings')
	 */
	class DashboardSettingsAPI {
		/**
		 * Returns the setting corresponding to the given name
		 * @param {string} name Name of the setting
		 * @return {object} Value of the setting; undefined if the setting does not exist; the following settings are core ones:
		 * - toolbarContainer - location of the selection toolbar - TODO: should be a element id
		 * - panelToolbarContainer - location of the panel toolbar - TODO: should also be an element id
		 * - performanceEnabled - used to show performance metrics in the serviceability panel
		 * - fonts - provide a list of additional custom fonts for text and title
		 * - panelWidth - sets the width of right hand side panels
		 * - productVersion - version of the product where the dashboard application lives
		 * - ClientValidDomainList - list if valid domains for image/web/media widget
		 * - applicationName - name of the dashboard application
		 * - applicationSettings - settings specific to the application; contains an options property - TODO: need to reviewed
		 * - applicationCssStyles - list of css files for the dashboard application
		 * - com.ibm.bi.dashboard.features - array of the dashboard feature definitions
		 * - com.ibm.bi.dashboard.content-features - array of the content feature definitions
		 * - com.ibm.bi.dashboard.serviceExtension - array of extensions - TODO: to convert into features
		 * - com.ibm.bi.dashboard.core-features - TODO: should be removed - old versions of om.ibm.bi.dashboard.features
		 * @example dashboardAPI.getFeature('DashboardSettings').get('fonts')
		 */
		get() {}
	}
	return DashboardSettingsAPI;
});
